// Generated by scripts/sync-catalog-sitemap.mjs — do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const providersSlugMap = {
    "1x2gaming": "1X2gaming",
    "avatarux": "AvatarUX",
    "aviator": "Aviator",
    "bgaming": "BGaming",
    "blueprint-gaming": "Blueprint Gaming",
    "boominggames": "BoomingGames",
    "creedroomz": "Creedroomz",
    "fantasma": "Fantasma",
    "fbastards": "Fbastards",
    "flush-originals": "Flush Originals",
    "gamingcorps": "GamingCorps",
    "gamomat-games": "Gamomat Games",
    "habanero": "Habanero",
    "hacksaw-gaming": "Hacksaw Gaming",
    "indigomagic": "IndigoMagic",
    "irondog": "IronDog",
    "microgaming": "MicroGaming",
    "microgaming-live": "MicroGaming Live",
    "million-games": "Million Games",
    "oryx-gaming": "Oryx Gaming",
    "peter-and-sons": "Peter & Sons",
    "pgsoft": "PGSoft",
    "play-n-go": "Play n GO",
    "playson": "Playson",
    "pragmatic-play": "Pragmatic Play",
    "pragmatic-play-live": "Pragmatic Play Live",
    "quickspin": "Quickspin",
    "relax-gaming": "Relax Gaming",
    "shadylady": "Shadylady",
    "slotmill": "Slotmill",
    "thunderkick": "Thunderkick",
    "tomhorn": "TomHorn",
    "wazdan": "Wazdan",
    "wickedgames": "Wickedgames",
    "winfast": "Winfast",
    "yggdrasil-gaming": "Yggdrasil Gaming",
};
